export default __webpack_public_path__ + "static/media/icon-Level_Target_Date.9e65f836.svg";